class CommonValue {
    public Value: string;

    constructor(fields?: Partial<CommonValue>) {
        Object.assign(this, fields);
    }
}

export { CommonValue };
